





















































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Coupon, Lottery, QreResult } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef, Loading } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";
import { generateDocumentId } from "@/common/generateDocumentId";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "ShopQreQreResultDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    uploadingFile: boolean;
    replaceIndex: number;
    loading: Loading;
    csvErrorData: string[];
    uploadCsv: boolean;
    userIds: string[];
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      uploadingFile: false,
      replaceIndex: -1,
      loading: new Loading(),
      csvErrorData: [],
      uploadCsv: false,
      userIds: []
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const querySnapshot = await db
        .collection(`/qreResult/${this.document.id}/answeredUsers`)
        .get();
      querySnapshot.forEach(doc => {
        this.userIds.push(doc.id);
      });
    } else {
      this.userIds = [];
    }
    if (!this.document.effective.pushSend) {
      this.document.effective.pushSend = false;
    }
  },
  computed: {
    collection(): Collection<QreResult> {
      const path = `/qreResult`;
      return new Collection(
        db.collection(path) as firestore.CollectionReference<QreResult>
      );
    },
    document(): Document<QreResult> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id ? "謝礼クーポン設定詳細" : "謝礼クーポン設定新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規謝礼クーポン設定";
    },
    saveButtonName(): string {
      return this.document?.data?.publishStatus != 2 ? "下書き保存" : "保存";
    },
    coupons(): List<Coupon> {
      return new Collection<Coupon>(
        db.collection("coupon") as firestore.CollectionReference<Coupon>
      ).query({
        filter: {
          shopId: { $eq: this.shopId },
          isQreCoupon: { $eq: 1 },
          publishStatus: { $eq: 2 }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    }
  },
  methods: {
    setNow() {
      this.document.effective.couponDistributeAt = this.formatFullDate(
        this.now
      );
      this.justifyNow = true;
    },
    async register() {
      if (
        this.document.effective.pushSend &&
        !this.document.effective.pushStatus
      ) {
        if (dayjs(this.document.effective.pushAt).valueOf() < Date.now()) {
          await alert({
            title: "エラー",
            text: "プッシュ配信を行う場合、配信日時は未来を設定してください。"
          });
          return;
        }
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return;
      }

      if (this.document.canSave) {
        this.loading.run(async () => {
          this.document.effective.shopId = this.shopId;
          if (this.uploadCsv) {
            // CSVアップロード中
            this.document.effective.csvUploadStatus = 1;
          }
          const result = await this.document.save().catch(e => {
            alert({
              title: "エラー",
              text: "謝礼クーポン設定の保存に失敗しました。"
            });
          });
          if (result) {
            if (this.uploadCsv) {
              const querySnapshot = await db
                .collection(`/qreResult/${this.document.id}/answeredUsers`)
                .get();
              if (querySnapshot.docs.length > 0) {
                const promises = [];
                let counter = 0;
                let batch = db.batch();
                for (const doc of querySnapshot.docs) {
                  counter++;
                  batch.delete(doc.ref);
                  if (counter >= 500) {
                    promises.push(batch.commit());
                    counter = 0;
                    batch = db.batch();
                  }
                }
                if (counter >= 1) {
                  promises.push(batch.commit());
                }
                await Promise.all(promises);
              }
              if (this.userIds.length > 0) {
                const promises = [];
                let counter = 0;
                let batch = db.batch();
                for (const userId of this.userIds) {
                  counter++;
                  const docRef = db
                    .collection(`/qreResult/${this.document.id}/answeredUsers`)
                    .doc(userId);
                  batch.set(docRef, { userId: userId });
                  if (counter >= 500) {
                    promises.push(batch.commit());
                    counter = 0;
                    batch = db.batch();
                  }
                }
                if (counter >= 1) {
                  promises.push(batch.commit());
                }
                await Promise.all(promises);
              }
              // CSVアップロード完了
              this.document.effective.csvUploadStatus = 2;
              const result = await this.document.save().catch(e => {
                alert({
                  title: "エラー",
                  text: "謝礼クーポン設定の保存に失敗しました。"
                });
              });
              if (!result) {
                return;
              }
            }
            this.$router.push("/shopqre/qreresult");
          }
        });
      } else {
        this.$router.push("/shopqre/qreresult");
      }
    },
    async registerAndPublish() {
      if (this.userIds.length <= 0) {
        alert({
          title: "エラー",
          text: "クーポン配布対象UID CSVが設定されていません。"
        });
      } else if (!this.document.effective.couponDistributeAt) {
        alert({
          title: "エラー",
          text: "クーポン配信日時が設定されていません。"
        });
      } else {
        this.document.effective.publishStatus = 2;
        if (!this.document.effective.pushStatus) {
          this.document.effective.pushStatus = 0;
        }
        await this.register();
      }
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/shopqre/qreresult");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    selectCsv() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    async uploadFile(event: Event) {
      this.csvErrorData = [];
      if (event.target instanceof HTMLInputElement) {
        console.log("uploadFile", event.target.files);
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択してください。"
          });
          event.target.value = "";
        } else {
          event.target.files.forEach((item: File) => {
            const reader = new FileReader();
            reader.onload = async () => {
              this.loading.run(async () => {
                if (!reader.result || typeof reader.result != "string") {
                  return;
                }
                const result = reader.result;
                console.log("replace.result", result);
                const csv = (window as any).jQuery.csv.toArrays(result);
                console.log(csv);
                // CSVバリデーション
                await this.validationCsv(csv);
                if (this.csvErrorData.length > 0) {
                  alert({
                    title: "エラー",
                    text:
                      "CSVが不正な値があります。エラー内容を確認してください。"
                  });
                } else {
                  this.userIds = [];
                  for (let i = 0; i < csv.length; i++) {
                    if (i == 0) {
                      continue;
                    }
                    const line = csv[i];
                    const csvData = this.convertCsvLine(line);
                    if (csvData.userId) {
                      this.userIds.push(csvData.userId);
                    }
                  }
                  this.uploadCsv = true;
                }
              });
            };
            reader.readAsText(item);
          });
          event.target.value = "";
        }
      }
    },
    async validationCsv(csv: any) {
      for (let i = 0; i < csv.length; i++) {
        const line = csv[i];
        if (1 != line.length) {
          this.csvErrorData.push(i + 1 + "行目 列数が指定と異なります。");
          continue;
        }
        //const csvData = this.convertCsvLine(line);
        //if (!csvData.userId) {
        //  this.csvErrorData.push(i + 1 + "行目 UIDが指定されていません。");
        //}
      }
    },
    convertCsvLine(line: any) {
      const result = {
        userId: line[0]
      };
      return result;
    }
  }
});
